import React, { useEffect } from "react";
import { useState } from "react";
import { MiFooter } from "../../components/footer/MiFooter";
import '../PerfilAgencia/PerfilAgenciaNuevo.css'
import '../PerfilAgencia/PerfilAgencia.css'
import { FormularioValoraciones } from "../../components/Valoraciones/FormularioValoraciones";
import HeaderHome from "../../components/headerHome/HeaderHome";

export const Valoraciones = (props) => {
    const [MenuLateralAux, setMenuLateralAux] = useState();

    const chageMenuLateralAux = () => {
        setMenuLateralAux(!MenuLateralAux)
    }

    return (
        <>
            <div className='PerfilAgencia'>
                <div className='headerPerfilAgencia'>
                    <HeaderHome
                        chageMenuLateralAux={chageMenuLateralAux}
                    />
                </div>
                <FormularioValoraciones />
                <div className='footerPerfilAgencia'>
                    <MiFooter />
                </div>
            </div>
        </>
    )
}